<form [formGroup]="form">
  <formly-form [fields]="fields" [form]="form" [model]="model"></formly-form>
</form>

<ng-template #similarItemsTemplate let-items="data">
  <astrobin-similar-items-suggestion
    [items]="items"
    (itemSelected)="suggestionSelected.emit($event)"
  ></astrobin-similar-items-suggestion>
</ng-template>
